import { Component, type ReactNode } from 'react';

interface Props {
    children: ReactNode;
    plainText: string;
}

interface State {
    failed: boolean;
}

class RecipientEmailErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { failed: false };
    }

    static getDerivedStateFromError(): State {
        return { failed: true };
    }

    render(): ReactNode {
        const { failed } = this.state;
        const { children, plainText } = this.props;
        if (!failed) return children;
        return (
            <div role="alert">
                <p>This email could not be formatted. Its readable text is shown below.</p>
                <pre style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                    {plainText || 'This email has no readable message text.'}
                </pre>
            </div>
        );
    }
}

export default RecipientEmailErrorBoundary;
